<template>
  <section class="options container">
    <ncc-switcher v-model="isModeForChildren" :label-after="__('label.modus.children')"/>
    <ncc-switcher v-model="isModeHsv" :label-before="__('label.modus.sv')" :label-after="__('label.modus.hsv')"/>
  </section>
</template>

<script>
    import NccSwitcher from "./NccSwitcher";
    export default {
        name: "NccQuestionOptionBar",
        components: {
            NccSwitcher
        },
        computed: {
            isModeForChildren: {
                get() {
                    return this.$store.getters['isModeForChildren'];
                },
                set(modeForChildren) {
                    this.$store.commit('SET_MODE_FOR_CHILDREN', modeForChildren)
                }
            },
            isModeHsv: {
                get() {
                    return this.$store.getters['isModeHSV'];
                },
                set(modeHSV) {
                    this.$store.commit('SET_MODE_HSV', modeHSV)
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
  .options {
    display: flex;
    justify-content: space-between;
    padding: 1rem;
    flex-direction: column;
  }

  @media all and (min-width: 769px) {
    .options {
      flex-direction: row;
    }
  }
</style>
